// --------------------------------------------------------------------------
// toggleAllFilters.js
// --------------------------------------------------------------------------

RN.toggleAllFilters = function() {

  'use strict';

  function init() {
    byBehaviour('toggle-all-filters').on('change', toggleAllFilters);
  }

  function toggleAllFilters(){
    var self = $(this),
        filters = self.closest('form').find('[data-element="filters"]').find('input[type="checkbox"]');

    filters.prop('checked', self.prop('checked'));
  }

  return {
    init: init
  };

}();